import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface AnimatedLogoProps {
  src: string;
  alt: string;
  size?: number;
  animation?: 'float' | 'pulse' | 'none';
  sx?: SxProps<Theme>;
}

const AnimatedLogo: React.FC<AnimatedLogoProps> = ({ 
  src, 
  alt, 
  size = 80, 
  animation = 'float',
  sx = {} 
}) => {
  const animationStyles = {
    float: {
      animation: 'float 3s ease-in-out infinite',
    },
    pulse: {
      animation: 'pulse-soft 2s ease-in-out infinite',
    },
    none: {},
  };

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        width: size,
        height: size,
        transition: 'transform 0.3s ease-in-out',
        '&:hover': {
          transform: 'scale(1.05)',
        },
        ...animationStyles[animation],
        ...sx,
      }}
    />
  );
};

export default AnimatedLogo;
